import { createFileRoute } from '@tanstack/react-router'
import { StaffPage } from '@/pages/staff'

export const Route = createFileRoute('/_authenticated/staff/')({
  staticData: { title: 'Staff' },
  component: StaffPage,
})
